import {useState, useImperativeHandle, forwardRef} from 'react';

export default forwardRef((props, ref) => {
  const [value, setValue] = useState('');

  let options_arr = props.options;

  let filter_id = props.filter_id ? `${props.filter_id}-custom-dropdown-filter` : 'custom-dropdown-filter';
  let select_id = props.filter_id ? `${props.filter_id}-dropdown` : 'dropdown';

  let initial_value = props.initial_value ? props.initial_value : 'All Cases';

  useImperativeHandle(ref, () => {
    return {
      onParentModelChanged(parentModel) {
        if (parentModel) {
          setValue(parentModel.state);
        } else {
          setValue('');
        }
      },
    };
  });

  const onFloatingFilterChange = (input) => {
    setValue(input);
    props.parentFilterInstance((instance) => {
      instance.setValue(input);
    });
  };

  return (
    <div id={filter_id} className="padding-left-2px">
      <select
        id={select_id}
        name={filter_id}
        value={value ? value : ''}
        onChange={(e) => onFloatingFilterChange(e.target.value)}
      >
        <option value="off" key="clear">
          {initial_value}
        </option>
        {options_arr.map((value) => (
          <option value={value} key={value}>
            {value}
          </option>
        ))}
      </select>
    </div>
  );
});
